//全局变量
const state = {
        //用户名
        username: '',
        //用户权限
        Jurisdiction: [],
        //秘钥
        token: '',
        //请求头
        Authorization: '',
        //来自企业的级别
        from_enterprise: '',
        //来自项目的级别
        from_projectId: '',
        //身份
        user_type: '',
        // userId
        user_id: '',
        //系统LOGO
        system_logo: '',
        //系统名称
        system_name: '智慧建造管理平台',
        //用户体验时间
        user_experience_time: '',
    }
    //改变变量只能通过方法执行改变
const mutations = {
    //同步方法
    SET_HEADER: (state, token) => {
        if (token === '' || token === null) {
            state.Authorization = ''
        } else {
            state.Authorization = 'Bearer ' + token
        }
    },
    GET_TOKEN: (state, token) => {
        state.token = token
    },
    GET_USERNAME: (state, username) => {
        state.username = username
    },
    GET_FROM_ENTERPRISE: (state, data) => {
        state.from_enterprise = data
    },
    GET_FROM_PROJECTID: (state, data) => {
        state.from_projectId = data
    },
    GET_USER_TYPE: (state, data) => {
        state.user_type = data
    },
    GET_USER_ID: (state, data) => {
        state.user_id = data
    },
    GET_SYSTEM_LOGO: (state, data) => {
        state.system_logo = process.env.BASE_API + data
    },
    GET_SYSTEM_NAME: (state, data) => {
        state.system_name = data
    },
    SET_USER_EXPERIENCE_TIME: (state, data) => {
        state.user_experience_time = data
    },


}
const actions = {
    // 异步执行调用方法,commit代表同步的方法提交,dispatch代表异步的方法提交
    // resolve返回的值,这个值就是方法运行结束后,所返回的值,可以是对象,也可以是变量
    // 异步方法需要按顺序执行时,或者需要当方法运行结束后需要干什么的时候,用到promise,方法后then调用后续函数
    setHeader({
        commit,
        dispatch,
        state
    }, token) {
        return new Promise(resolve => {
            commit('SET_HEADER', token)
            dispatch('getToken', token)
            resolve({
                Authorization: state.Authorization,
                token: state.token
            })
        })
    },
    getToken({
        commit,
        state
    }, token) {
        return new Promise(resolve => {
            commit('GET_TOKEN', token)
            resolve(state.token)
        })
    },
    get_username({ commit }, username) {
        commit('GET_USERNAME', username)
    },
    get_from_enterprise({ commit }, data) {
        commit('GET_FROM_ENTERPRISE', data)
    },
    get_from_projectId({ commit }, data) {
        commit('GET_FROM_PROJECTID', data)
    },
    get_user_type({ commit }, data) {
        commit('GET_USER_TYPE', data)
    },
    get_user_id({ commit }, data) {
        commit('GET_USER_ID', data)
    },
    get_system_logo({ commit }, data) {
        commit('GET_SYSTEM_LOGO', data)
    },
    get_system_name({ commit }, data) {
        commit('GET_SYSTEM_NAME', data)
    },
    set_user_experience_time({ commit }, data) {
        commit('SET_USER_EXPERIENCE_TIME', data)
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js